import React, { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import venomContext from "../../context/venomContext";
import classNames from "classnames";
import { toast } from "react-toastify";
import $ from "jquery";

export default function Header(props) {
  const { setAlertIsActive, setActionName } = props;
  const context = useContext(venomContext);
  const { allBlogs, Logout } = context;
  const navigate = useNavigate();
  const theme_color = localStorage.getItem("theme");
  setInterval(() => {
    console.log('triggered')
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
      navigate("/login");
      toast.info("Session expired. Please login again to continue.", {
        position: "bottom-right",
      });
    }
  }, 
  // Expire After 2 Days
  172800000
  )
  return (
    <>
      <header className={props.bgColor}>
        <div className="container py-4">
          <nav className="d-flex justify-content-between align-items-center">
            <div>
              <div className="logo">
                <Link to="/" onClick={async () => await allBlogs()}>
                  <h4 className="m-0">
                    {" "}
                    Ve
                    <span className={"text-" + theme_color}>nom</span>
                  </h4>
                </Link>
              </div>
            </div>
            <div className="account">
              {localStorage.getItem("token") ? (
                <>
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      onClick={() => {
                        if ($(".dash").length > 0) {
                          setAlertIsActive(true);
                          setActionName("logout");
                        } else {
                          Logout();
                        }
                      }}
                      className={"btn btn-md btn-" + theme_color}
                    >
                      Logout
                    </button>
                    <button
                      type="button"
                      onClick={() => navigate("/dash/all")}
                      className={classNames(
                        "btn btn-md ms-2 btn-" + theme_color,
                        {
                          "d-none": props.isDash,
                        }
                      )}
                    >
                      Go Dash
                    </button>
                  </div>
                </>
              ) : (
                <Link
                  to="/login"
                  type="button"
                  className={"btn btn-md btn-" + theme_color}
                >
                  Login
                </Link>
              )}
            </div>
          </nav>
        </div>
      </header>
    </>
  );
}
